export enum AuditionFlag {
  GREEN_FLAG = 'Green Flag',
  RED_FLAG = 'Red Flag',
  ORANGE_FLAG = 'Orange Flag',
}
